const productsData = [
    {
        id: 1,
        tag: "hero-product",
        tagline: "STYLISH NEW SHOES.",
        heroImage: "/images/products/1.png",
        images: [
            "/images/products/1.png",
            "/images/products/2.png",
            "/images/products/3.png",
            "/images/products/3.png",
        ],
        brand: "BLACK",
        title: "CONVERSE",
        info: "WOMEN SIZE 6",
        category: "Women trainers",
        finalPrice: 72,
        originalPrice: 80,
        quantity: 1,
        ratings: 1234,
        rateCount: 10,
        path: "/product-details/",
    },
    {
        id: 2,
        tag: "featured-product",
        images: [
            "/images/products/5.png",
            "/images/products/6.png",
            "/images/products/7.png",
            "/images/products/8.png"
        ],
        brand: "WHITE",
        title: "CONVERSE",
        info: "WOMEN SIZE 7",
        category: "Women trainers",
        finalPrice: 117,
        originalPrice: 130,
        quantity: 1,
        ratings: 1321,
        rateCount: 5,
        path: "/product-details/",
    },
    {
        id: 3,
        tag: "hero-product",
        tagline: "Shoes for comfort all-day.",
        heroImage: "/images/products/3.png",
        images: [
            "/images/products/9.png",
            "/images/products/10.png",
            "/images/products/11.png",
            "/images/products/12.png",
        ],
        brand: "GREEN",
        title: "LILLY",
        info: "WOMEN SIZE 5",
        category: "Women heels",
        finalPrice: 162,
        originalPrice: 180,
        quantity: 1,
        ratings: 1244,
        rateCount: 5,
        path: "/product-details/",
    },
    {
        id: 4,
        images: [
            "/images/products/13.png",
            "/images/products/14.png",
            "/images/products/15.png",
            "/images/products/16.png",
        ],
        brand: "WHITE",
        title: "CONVERSE",
        info: "MEN SIZE 9",
        category: "Men tainers",
        finalPrice: 180,
        originalPrice: 200,
        quantity: 1,
        ratings: 556,
        rateCount: 4,
        path: "/product-details/",
    },
    {
        id: 5,
        images: [
            "/images/products/17.png",
            "/images/products/18.png",
            "/images/products/19.png",
            "/images/products/20.png",
        ],
        brand: "BLACK",
        title: "VANS",
        info: "MEN SIZE 11",
        category: "Men trainers",
        finalPrice: 45,
        originalPrice: 50,
        quantity: 1,
        ratings: 1563,
        rateCount: 5,
        path: "/product-details/",
    },
    {
        id: 6,
        images: [
            "/images/products/21.png",
            "/images/products/22.png",
            "/images/products/23.png",
            "/images/products/24.png",
        ],
        brand: "WHITE",
        title: "CROCS",
        info: "MEN SIZE 10",
        category: "Men slippers",
        finalPrice: 90,
        originalPrice: 100,
        quantity: 1,
        ratings: 836,
        rateCount: 4,
        path: "/product-details/",
    },
    {
        id: 7,
        tag: "hero-product",
        tagline: "WHITE CLASSIC CROCS.",
        heroImage: "/images/products/21.png",
        images: [
            "/images/products/25.png",
            "/images/products/26.png",
            "/images/products/27.png",
            "/images/products/28.png",
        ],
        brand: "WHITE",
        title: "CROCS",
        info: "MEN SIZE 10",
        category: "Men slippers",
        finalPrice: 108,
        originalPrice: 120,
        quantity: 1,
        ratings: 679,
        rateCount: 4,
        path: "/product-details/",
    },
    {
        id: 8,
        tag: "featured-product",
        images: [
            "/images/products/29.png",
            "/images/products/30.png",
            "/images/products/31.png",
            "/images/products/32.png",
        ],
        brand: "WHITE",
        title: "NIKE",
        info: "MEN SIZE 8",
        category: "Men trainers",
        finalPrice: 135,
        originalPrice: 150,
        quantity: 1,
        ratings: 755,
        rateCount: 4,
        path: "/product-details/",
    },
    {
      id: 9,
      tag: "hero-product",
      tagline: "STYLISH NEW SHOES.",
      heroImage: "/images/products/1.png",
      images: [
          "/images/products/1.png",
          "/images/products/2.png",
          "/images/products/3.png",
          "/images/products/3.png",
      ],
      brand: "BLACK",
      title: "CONVERSE",
      info: "WOMEN SIZE 6",
      category: "Women trainers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 0,
      ratings: 1234,
      rateCount: 10,
      path: "/product-details/",
  },
  {
      id: 10,
      tag: "featured-product",
      images: [
          "/images/products/5.png",
          "/images/products/6.png",
          "/images/products/7.png",
          "/images/products/8.png"
      ],
      brand: "WHITE",
      title: "CONVERSE",
      info: "WOMEN SIZE 6",
      category: "Women trainers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 1321,
      rateCount: 5,
      path: "/product-details/",
  },
  {
      id: 11,
      tag: "hero-product",
      tagline: "Shoes for comfort all-day.",
      heroImage: "/images/products/3.png",
      images: [
          "/images/products/9.png",
          "/images/products/10.png",
          "/images/products/11.png",
          "/images/products/12.png",
      ],
      brand: "GREEN",
      title: "LILLY",
      info: "WOMEN SIZE 6",
      category: "Women heels",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 1244,
      rateCount: 5,
      path: "/product-details/",
  },
  {
      id: 12,
      images: [
          "/images/products/13.png",
          "/images/products/14.png",
          "/images/products/15.png",
          "/images/products/16.png",
      ],
      brand: "WHITE",
      title: "CONVERSE",
      info: "MEN SIZE 11",
      category: "Men tainers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 556,
      rateCount: 4,
      path: "/product-details/",
  },
  {
      id: 13,
      images: [
          "/images/products/17.png",
          "/images/products/18.png",
          "/images/products/19.png",
          "/images/products/20.png",
      ],
      brand: "BLACK",
      title: "VANS",
      info: "MEN SIZE 12",
      category: "Men trainers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 1563,
      rateCount: 5,
      path: "/product-details/",
  },
  {
      id: 14,
      images: [
          "/images/products/21.png",
          "/images/products/22.png",
          "/images/products/23.png",
          "/images/products/24.png",
      ],
      brand: "WHITE",
      title: "CROCS",
      info: "MEN SIZE 13",
      category: "Men slippers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 836,
      rateCount: 4,
      path: "/product-details/",
  },
  {
      id: 15,
      tag: "hero-product",
      tagline: "WHITE CLASSIC CROCS.",
      heroImage: "/images/products/21.png",
      images: [
          "/images/products/25.png",
          "/images/products/26.png",
          "/images/products/27.png",
          "/images/products/28.png",
      ],
      brand: "WHITE",
      title: "CROCS",
      info: "MEN SIZE 9",
      category: "Men slippers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 679,
      rateCount: 4,
      path: "/product-details/",
  },
  {
      id: 16,
      tag: "featured-product",
      images: [
          "/images/products/29.png",
          "/images/products/30.png",
          "/images/products/31.png",
          "/images/products/32.png",
      ],
      brand: "WHITE",
      title: "NIKE",
      info: "MEN SIZE 10",
      category: "Men trainers",
      finalPrice: 72,
      originalPrice: 80,
      quantity: 1,
      ratings: 755,
      rateCount: 4,
      path: "/product-details/",
  },

];

export default productsData;